/**
 * @module FE-CU53_ユーザー登録画面_本登録
 */
import Header from '../../../components/header/Header.vue';
import BreadCrumbList from '@/components/breadCrumb/List.vue';
import PcPageTitle from '../../../components/pcPageTitle/PcPageTitle.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../../constants';

const PAGE_ID = 'FE-CU53';

import {
  nameClass,
  passwordClass,
  questionClass,
  answerClass,
  genderClass,
  birthyearClass,
  hiraganaPattern,
  passwordPattern,
} from './computed';

export default {
  name: 'UserRegistration',
  components: {
    Header,
    PcPageTitle,
    BreadCrumbList,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU53ユーザー登録画面本登録.ユーザー登録本登録'),
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU53ユーザー登録画面本登録.C0001'),
      customerNumber: '',
      displayDistrictNickname: '',
      securityDestinationName: '',
      name: '',
      password: '',
      confirmPassword: '',
      question: '',
      answer: '',
      gender: 1,
      birthyear: null,
      showPassword: false,
      showConfirmPassword: false,
      nameError: '',
      passwordError: '',
      confirmPasswordError: '',
      questionError: '',
      answerError: '',
      usagePlanId: null,
      error: {
        hasNameError: false,
        hasPasswordError: false,
        hasQuestionError: false,
        hasAnswerError: false,
        hasGenderError: false,
        hasBirthyearError: false,
      },
      genders: [
        {
          value: 1,
          text: vm.$vuetify.lang.t('$vuetify.FECU53ユーザー登録画面本登録.性別セレクト.未指定'),
        },
        {
          value: 2,
          text: vm.$vuetify.lang.t('$vuetify.FECU53ユーザー登録画面本登録.性別セレクト.男性'),
        },
        {
          value: 3,
          text: vm.$vuetify.lang.t('$vuetify.FECU53ユーザー登録画面本登録.性別セレクト.女性'),
        },
      ],
      valid: true,
      navRoute: '',
      modified: '',
      type: '',
      width: 0,
      widthFormTitle: 0,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    nameClass,
    passwordClass,
    questionClass,
    answerClass,
    genderClass,
    birthyearClass,
    hiraganaPattern,
    passwordPattern,
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU53ユーザー登録画面本登録.ユーザー登録本登録'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU53ユーザー登録画面本登録.C0001'),
        genders: [
          {
            value: 1,
            text: vm.$vuetify.lang.t('$vuetify.FECU53ユーザー登録画面本登録.性別セレクト.未指定'),
          },
          {
            value: 2,
            text: vm.$vuetify.lang.t('$vuetify.FECU53ユーザー登録画面本登録.性別セレクト.男性'),
          },
          {
            value: 3,
            text: vm.$vuetify.lang.t('$vuetify.FECU53ユーザー登録画面本登録.性別セレクト.女性'),
          },
        ],
        birthyearUnspecified: vm.$vuetify.lang.t(
          '$vuetify.FECU53ユーザー登録画面本登録.生年セレクト.未指定'
        ),
      };
    },
    birthyears(vm) {
      const birthyears = [];

      birthyears.push({
        value: null,
        text: vm.$vuetify.lang.t('$vuetify.FECU53ユーザー登録画面本登録.生年セレクト.未指定'),
      });

      const year = new Date().getFullYear();
      for (let i = year; i >= this.CONSTANTS.MIN_BIRTH_YEAR; i--) {
        birthyears.push({
          value: i,
          text: this.$vuetify.lang.t('$vuetify.FECU53ユーザー登録画面本登録.生年セレクト.生年', i),
        });
      }
      return birthyears;
    },
    /**
     * 氏名 バリデーションチェック
     * @returns {string} エラーメッセージ
     */
    nameRule() {
      return [
        !!this.name ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU53ユーザー登録画面本登録.E0001'),
      ];
    },
    /**
     * パスワード バリデーションチェック
     * @returns {string} エラーメッセージ
     */
    passwordRule() {
      if (this.password === '') {
        return [this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU53ユーザー登録画面本登録.E0003')];
      }

      if (this.password.length < 8) {
        return [this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU53ユーザー登録画面本登録.E0019')];
      }

      if (!this.passwordPattern.test(this.password)) {
        return [this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU53ユーザー登録画面本登録.E0014')];
      }
    },
    /**
     * パスワード(確認用) バリデーションチェック
     * @returns {string} エラーメッセージ
     */
    confirmPasswordRule() {
      if (this.confirmPassword === '') {
        return [this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU53ユーザー登録画面本登録.E0004')];
      }

      if (this.confirmPassword.length < 8) {
        return [this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU53ユーザー登録画面本登録.E0020')];
      }

      if (!this.passwordPattern.test(this.confirmPassword)) {
        return [this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU53ユーザー登録画面本登録.E0016')];
      }

      if (this.password !== this.confirmPassword) {
        return [this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU53ユーザー登録画面本登録.E0005')];
      }
    },
    /**
     * 秘密の質問 バリデーションチェック
     * @returns {string} エラーメッセージ
     */
    secretRule() {
      return [
        !!this.question ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU53ユーザー登録画面本登録.E0006'),
      ];
    },
    /**
     * 回答 バリデーションチェック
     * @returns {string} エラーメッセージ
     */
    answerRule() {
      if (this.answer === '') {
        return [this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU53ユーザー登録画面本登録.E0008')];
      }

      if (!this.hiraganaPattern.test(this.answer)) {
        return [this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU53ユーザー登録画面本登録.E0017')];
      }
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 登録確認ダイアログ呼び出し処理
     */
    async submit() {
      const result = await this.$agreementDialog(
        '$vuetify.FECU53ユーザー登録画面本登録.確認',
        '$vuetify.FECU53ユーザー登録画面本登録.入力された内容でユーザー登録を行います',
        '$vuetify.FECU53ユーザー登録画面本登録.いいえボタン',
        '$vuetify.FECU53ユーザー登録画面本登録.はいボタン'
      );
      if (result === true) {
        // OK
        this.APP_CU5302();
      } else {
        // キャンセル
      }
    },
    /**
     * 初期表示API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns apiData レスポンス
     */
    APP_CU5301: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = response.data;
            // // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     oneTimeUrlStatus: 0, // 0:正常 1:存在しないURL
            //     userInfo: {
            //       customerNumber: "51-1234567", // お客様番号
            //       displayDistrictNickname: "綜警太郎宅", // 警備先名称
            //       usagePlanId: 2,
            //       securityDestinationName: "表示ニック",
            //     },
            //   },
            //   modified: "modified",
            // };
            if (apiData.contentsInfo.oneTimeUrlStatus == 1) {
              // Thanks画面に遷移し失効したワンタイムURLのメッセージを表示する。
              this.$store.commit('setThanksType', {
                fromPageInfo: { page: 53 },
                displayType: 5,
              });
              this.$router.replace({ path: '/thanks' });
            }

            this.usagePlanId = apiData.contentsInfo.userInfo.usagePlanId;
            this.customerNumber = apiData.contentsInfo.userInfo.customerNumber;
            this.securityDestinationName = apiData.contentsInfo.userInfo.securityDestinationName;
            this.displayDistrictNickname = apiData.contentsInfo.userInfo.displayDistrictNickname;

            this.modified = apiData.contentsInfo.modified;
          },
          (error /* eslint-disable-line */) => {
            if (
              error.response.status == '400' &&
              error.response.data.errorCode == 'BE-CO02-E0048'
            ) {
              // ダイアログが閉じられたときにログイン画面に遷移する
              this.$errorDialog(
                '$vuetify.メッセージ一覧.FECU53ユーザー登録画面本登録.E0023',
                false,
                false,
                '/login'
              );
            } else {
              // 異常系処理
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      // console.log("APP_CU5301>>>", apiData);
      return apiData;
    },
    /**
     * ユーザー登録API実行
     */
    APP_CU5302: async function () {
      // 正常系を確認したい場合は下記のコメントを解除する
      // let param = "post"; // 検証用
      let param = '/api/userRegistration/registration'; // 本番用

      let queries = {
        oneTimeUrlId: this.$route.params.oneTimeUrlID,
        name: this.name,
        password: this.password,
        question: this.question,
        answer: this.answer,
        gender: this.gender,
        birthyear: this.birthyear,
        modified: this.modified,
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     oneTimeUrlStatus: 1, // 0:正常 1:存在しないURL
            //   },
            // };

            if (apiData.contentsInfo.oneTimeUrlStatus == 1) {
              // Thanks画面に遷移し失効したワンタイムURLのメッセージを表示する。
              this.$store.commit('setThanksType', {
                fromPageInfo: { page: 0 },
                displayType: 5,
              });
            } else {
              // Thanks画面に遷移する。
              if (this.$route.params.branch.indexOf('main') != -1) {
                // メインユーザーの場合
                this.$store.commit('setThanksType', {
                  fromPageInfo: { page: 532 },
                  displayType: 2,
                });
              } else {
                // サブユーザーの場合
                this.$store.commit('setThanksType', {
                  fromPageInfo: { page: 531 },
                  displayType: 2,
                });
              }
            }
            this.$router.replace({ path: '/thanks' });
          },
          (error) => {
            if (error.response.status == '400') {
              // エラーダイアログ(FE-CU53-E0012)を表示する。
              this.$errorDialog('$vuetify.メッセージ一覧.FECU53ユーザー登録画面本登録.E0012');
            } else {
              // 異常系処理
              this.$_abnormality(error.response.status);
            }
          }
        );
      // console.log("APP_CU5302>>>", apiData);
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 検証の際には以下URLで遷移可能
    // ~~/userRegistration/main/1 メインユーザーの本登録
    // ~~/userRegistration/sub/1 サブユーザーの本登録

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    this.width =
      this.$mq === 'pc' ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP;
    // 微調整
    this.widthFormTitle = this.width + 10;

    // 画面サイズ変更
    this.$watch('$mq', function () {
      this.width =
        this.$mq === 'pc'
          ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC
          : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP;

      // 微調整
      this.widthFormTitle = this.width + 10;
    });

    this.birthyear = null;

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    //ローディングマーク表示と合わせて色々再見直ししたほうが良いかも
    this.isShowPage = true;

    let param = '/api/userRegistration/init'; // 本番用

    let queries = {
      oneTimeUrlId: this.$route.params.oneTimeUrlID, // oneTimeUrlIDを取得
    };

    let method = 'post';
    await this.APP_CU5301(param, queries, method);
  },
};
